// src/auth/screens/BootSpinner.jsx
import React from 'react';

export default function BootSpinner() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0e0e18' }}>
      <div style={{ color: '#e4e4ec', fontFamily: "'DM Sans', sans-serif", fontSize: '14px', opacity: 0.6 }}>
        Caricamento...
      </div>
    </div>
  );
}
